import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import Header from '../../components/feature/Header'
import HeroSection from './components/HeroSection'
import TrendingThreads from './components/TrendingThreads'
import LatestNews from './components/LatestNews'
import FeaturedAIDramas from './components/FeaturedAIDramas'
import FeaturedDiscussions from './components/FeaturedDiscussions'
import PopularDramas from './components/PopularDramas'
import PopularDramasCarousel from './components/PopularDramasCarousel'
import NewDramasCarousel from './components/NewDramasCarousel'
import FeaturedCreators from './components/FeaturedCreators'
import CreatorShowcase from './components/CreatorShowcase'
import CommunityCategories from './components/CommunityCategories'
import Footer from './components/Footer'
import CommunityActivityFeed from './components/CommunityActivityFeed'
import WeeklyTrendingTopics from './components/WeeklyTrendingTopics'
import BannerWidget from './components/BannerWidget'
import LeaderboardWidget from './components/LeaderboardWidget'
import CommunityEventsCalendar from './components/CommunityEventsCalendar'
import FeaturedGroups from './components/FeaturedGroups'

const HomePage = () => {
  const [searchParams] = useSearchParams()

  useEffect(() => {
    const verified = searchParams.get('verified')
    if (verified === 'true') {
      // Show success message for email verification
      console.log('Email verified successfully!')
    }
  }, [searchParams])

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      {/* Hero Section */}
      <HeroSection />
      
      {/* Main Content - Two Column Layout */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          
          {/* Left Column - 2/3 width */}
          <div className="lg:col-span-2 space-y-8">
            {/* Trending Discussions */}
            <TrendingThreads />
            
            {/* Latest Industry News */}
            <LatestNews />
            
            {/* Featured AI Dramas */}
            <FeaturedAIDramas />
            
            {/* Featured Discussions */}
            <FeaturedDiscussions />
            
            {/* Popular Dramas This Week Carousel */}
            <PopularDramasCarousel />
            
            {/* New Dramas This Week Carousel */}
            <NewDramasCarousel />
            
            {/* Popular Dramas */}
            <PopularDramas />
            
            {/* Featured Creators */}
            <FeaturedCreators />
            
            {/* Creator Showcase Gallery */}
            <CreatorShowcase />
          </div>
          
          {/* Right Column - 1/3 width */}
          <div className="space-y-8">
            {/* Sidebar */}
            <div className="space-y-6">
              {/* Banner Widget for Ads */}
              <BannerWidget />
              
              {/* Leaderboard */}
              <LeaderboardWidget />
              
              {/* Featured Groups */}
              <FeaturedGroups />
              
              {/* Community Events Calendar - Now as sidebar widget */}
              <CommunityEventsCalendar />
              
              {/* Activity Feed */}
              <CommunityActivityFeed />
              
              {/* Weekly Trending Topics */}
              <WeeklyTrendingTopics />
              
              {/* Community Categories */}
              <CommunityCategories />
            </div>
          </div>
        </div>
      </div>
      
      {/* Footer */}
      <Footer />
    </div>
  )
}

export default HomePage
